/*
 * Cart upsell — handler del botón "Agregar".
 * Agrega el producto al carrito vía AJAX (/cart/add.js) con la line item
 * property `_from_cart_upsell="true"`. Esa property es la ÚNICA forma de
 * activar la Shopify Function "Oferta exclusiva del carrito" (25% off): sin
 * ella el producto se cobra a precio de lista aunque esté en la colección.
 * El 25% se apila encima de los códigos de descuento de orden.
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;


  async function addUpsellToCart(variantId, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: quantity || 1,
            properties: { _from_cart_upsell: "true" },
          },
        ],
      }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || "No se pudo agregar al carrito");
    }
    return res.json();
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
    if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === "function") {
      try { window.theme.cart.refresh(); } catch (e) { /* noop */ }
    }
  }

  /* Auditoría sep-2026 #42: el bloque se renderiza UNA vez (api-cart-items no lo re-evalúa),
     así que al cambiar el carrito se reordena/etiqueta aquí: el candidato más barato cuya
     oferta cruza lo que falta para envío gratis va primero con el chip "+ ENVÍO GRATIS",
     y se oculta lo que ya está en el carrito. Fuente de verdad: /cart.js (1 fetch, debounced). */
  function money(cents) {
    var n = Math.round(cents) / 100;
    return "$" + n.toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  // Bloque 14: al cambiar la talla el precio se re-pinta con el MISMO formato que Liquid ("$ 1,019.25"),
  // con centavos exactos (15500 × 0.75 = 11625 → $ 116.25), sin redondear a pesos.
  function moneyPrice(cents) {
    var n = Math.round(cents) / 100;
    return "$ " + n.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  /* Bloque 12/14: con el carrito real (o el DOM ya re-renderizado) sincroniza (a) "Complétalo con" en /cart
     (sin complementos con carrito vacío), (b) la nota de preventa del pie del carrito y (c) el plazo de entrega. */
  function syncCartExtras(cart) {
    var count = cart ? (cart.item_count || 0) : document.querySelectorAll("[data-cart-item]").length;
    document.querySelectorAll("[data-uk-cart-complements]").forEach(function (el) { el.hidden = !count; });
    var preorder = !!document.querySelector('[data-cart-item][data-uk-preorder="true"]');
    document.querySelectorAll("[data-uk-cart-preorder]").forEach(function (el) { el.hidden = !preorder; });
    document.querySelectorAll("[data-uk-cart-delivery]").forEach(function (el) {
      el.textContent = preorder ? "" : "Entrega desde el despacho: 1–3 días hábiles (2–5 en zonas remotas).";
    });
  }
  function applyThreshold(cart) {
    syncCartExtras(cart);
    var box = document.querySelector("[data-cart-upsell]");
    if (!box || !cart) return;
    box.hidden = !cart.item_count;
    var limit = parseInt(box.getAttribute("data-free-limit"), 10) || 0;
    var envio = parseInt(box.getAttribute("data-envio"), 10) || 0;
    // A code on the order can change the effective contribution of the new item.
    // Only promise crossing the threshold when no order discount must be recomputed.
    var hasOrderDiscount = (cart.cart_level_discount_applications || []).length > 0;
    var faltante = limit > 0 && !hasOrderDiscount ? limit - (cart.total_price || 0) : 0;
    var inCart = {};
    (cart.items || []).forEach(function (it) { if (it.handle) inCart[it.handle] = true; });
    var wrap = box.querySelector(".cart-upsell__items");
    if (!wrap) return;
    var items = Array.prototype.slice.call(wrap.querySelectorAll(".cart-upsell__item"));
    var best = null;
    items.forEach(function (el) {
      var h = el.getAttribute("data-cart-upsell-handle");
      var po = parseInt(el.getAttribute("data-price-off"), 10) || 0;
      el.hidden = !!inCart[h];
      if (!el.hidden && faltante > 0 && po >= faltante && (!best || po < parseInt(best.getAttribute("data-price-off"), 10))) best = el;
    });
    items.forEach(function (el) {
      var isBest = el === best;
      var po = parseInt(el.getAttribute("data-price-off"), 10) || 0;
      el.classList.toggle("cart-upsell__item--cross", isBest);
      if (isBest) el.setAttribute("data-crosses-threshold", ""); else el.removeAttribute("data-crosses-threshold");
      var chip = el.querySelector("[data-cart-upsell-chip]");
      if (isBest && !chip) {
        chip = document.createElement("span");
        chip.className = "cart-upsell__chip";
        chip.setAttribute("data-cart-upsell-chip", "");
        chip.textContent = "+ ENVÍO GRATIS";
        el.insertBefore(chip, el.firstChild);
      } else if (!isBest && chip) chip.remove();
      var note = el.querySelector("[data-cart-upsell-note]");
      if (note) {
        var neto = po - envio;
        if (isBest && neto > 0) { note.textContent = "Te sale en " + money(neto) + " netos en vez de pagar " + money(envio) + " de envío"; note.hidden = false; }
        else { note.textContent = ""; note.hidden = true; }
      }
    });
    box.hidden = !cart.item_count || items.every(function (el) { return el.hidden; });
    if (best && wrap.firstElementChild !== best) wrap.insertBefore(best, wrap.firstElementChild);
  }
  var thTimer = null;
  function scheduleThreshold() {
    clearTimeout(thTimer);
    thTimer = setTimeout(function () {
      if (!document.querySelector("[data-cart-upsell]")) return;
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(applyThreshold)
        .catch(function () {});
    }, 350);
  }
  // Bloque 14: además de los eventos que ya escuchaba LIVE, theme:cart:added/loaded (posteriores a la respuesta)
  ["cart:refresh", "theme:cart:refresh", "theme:cart:change", "theme:cart:added", "theme:cart:loaded", "ajaxProduct:added"].forEach(function (ev) {
    document.addEventListener(ev, scheduleThreshold);
  });
  document.addEventListener("theme:cart:loaded", function () { syncCartExtras(null); });
  if (document.readyState !== "loading") syncCartExtras(null); else document.addEventListener("DOMContentLoaded", function () { syncCartExtras(null); });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("select[data-cart-upsell-size]");
    if (!select) return;
    var option = select.selectedOptions[0], item = select.closest(".cart-upsell__item");
    if (!option || !item || !option.dataset.priceOff) return;
    item.dataset.priceOff = option.dataset.priceOff;
    item.querySelector(".cart-upsell__price-final").textContent = moneyPrice(Number(option.dataset.priceOff));
    item.querySelector(".cart-upsell__price-original").textContent = moneyPrice(Number(option.dataset.price));
    scheduleThreshold();
  });

  // Capture phase so other listeners (theme cart drawer) can't stopPropagation us first.
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest && e.target.closest("[data-cart-upsell-add]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    console.info("[cart-upsell] click", btn);

    const item = btn.closest(".cart-upsell__item");
    const sizeEl = item ? item.querySelector("[data-cart-upsell-size]") : null;
    const variantId = sizeEl ? sizeEl.value : null;

    if (!variantId) {
      console.warn("[cart-upsell] No variant selected");
      return;
    }

    if (!btn.dataset.originalLabel) {
      btn.dataset.originalLabel = btn.textContent.trim();
    }

    btn.disabled = true;
    btn.textContent = "Agregando…";
    btn.removeAttribute("data-state");
    btn.classList.remove("uk-ok");

    var errorBox = btn.closest("[data-cart-upsell]").querySelector("[data-cart-upsell-error]");
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ""; }
    try {
      await addUpsellToCart(variantId, 1);
      document.dispatchEvent(new CustomEvent("uk:cart-add-result", {detail:{ok:true,source:"upsell",variant_id:String(variantId),quantity:1}}));
      btn.dataset.state = "added";
      // 28-sep-2026 tipografía: la palomita de texto (U+2713) no existe en el Montserrat del CDN y caía a otra fuente. Ahora
      // la pinta .uk-ok::before (máscara de icon-check.svg, uk-type.css) en currentColor.
      btn.textContent = "Agregado";
      btn.classList.add("uk-ok");
      refreshCartUI();
      setTimeout(() => {
        btn.removeAttribute("data-state");
        btn.classList.remove("uk-ok");
        btn.textContent = btn.dataset.originalLabel;
        btn.disabled = false;
      }, 1800);
    } catch (err) {
      document.dispatchEvent(new CustomEvent("uk:cart-add-result", {detail:{ok:false,source:"upsell"}}));
      if (errorBox) { errorBox.textContent = err.message || "No pudimos agregar este artículo. Inténtalo de nuevo."; errorBox.hidden = false; }
      btn.classList.remove("uk-ok");
      btn.textContent = btn.dataset.originalLabel;
      btn.disabled = false;
    }
  }, true);
})();
